import HeroBg from "public/oemConverged/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Transform your IT operations with converged architecture",
    link: "contact-us",
  },
  desc: "Maximize performance and efficiency with OEM Converged Architecture, integrating hardware, software, and networking into a cohesive cloud ecosystem. Ideal for industries that demand reliability, agility, and scalability.",
  title: "Unified IT Infrastructure for OEM Solutions",
  image: HeroBg,
};
